import { FC, useState } from "react";
import styles from './ChallengeDetailHelpImage.module.scss';
import { InfoSnackbar } from "../../../../components/InfoSnackbar/InfoSnackbar";

interface IChallengeDetailHelpImageProps {
    image: string;
    helpText?: string;
}

export const ChallengeDetailHelpImage: FC<IChallengeDetailHelpImageProps> = ({ image, helpText }) => {
    const [toolTipMessage, setToolTipMessage] = useState('');

    const showTooltip = () => helpText && setToolTipMessage(helpText);

    return (
        <div onClick={ () => showTooltip() }>
            <img className={styles.image} alt={image} src={ image } />
            { toolTipMessage && <InfoSnackbar infoMessage={ toolTipMessage } onCloseHandler={ () => setToolTipMessage('') } /> }
        </div>
    );
}